/* eslint-disable */
import React from "react";
import { assetImages } from "constants";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const IndexFaqsModal = ({
  startIndex = () => {},
  cancelIndex = () => {},
  isLoading = false
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();
  return (
    <div
      className="modal fade"
      id="indexingWarning"
      tabIndex="-1"
      aria-labelledby="indexingWarningLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-body text-center px-4 py-5">
            <img
              src={assetImages.exclamationIcon}
              alt="warning"
              className="img-fluid"
            />
            {isLoading ? (
              <>
                <div className="my-4 d-flex flex-column align-items-center justify-content-center">
                  <div
                    className="spinner-border text-primary mb-3"
                    style={{ width: "3rem", height: "3rem" }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <h2>{t("Indexing the selected faqs")}</h2>
                </div>
              </>
            ) : (
              <>
                <h2>
                  {t(`Agree with the terms and conditions to start indexing`)} ?
                </h2>
                {/* <h3>** Task with logs can't be deleted</h3> */}
                <div className="d-flex gap-3 justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-primary"
                    onClick={startIndex}
                  >
                    {t("Yes Start Indexing")}
                  </Link>

                  <Link
                    to="#"
                    className="btn btn-outline-primary"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={cancelIndex}
                  >
                    {t("No, Cancel")}
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndexFaqsModal;
